import React from 'react';
import { useDevAuth } from '../hooks/useDevAuth';

interface DevAuthProviderProps {
  children: React.ReactNode;
}

export const DevAuthProvider: React.FC<DevAuthProviderProps> = ({ children }) => {
  const { isAuthenticated, shop, login, logout } = useDevAuth();

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Photo Upload Form</h1>
            <p className="text-gray-600 mb-8">開発環境での認証</p>
          </div>
          
          <div className="bg-white py-8 px-6 shadow-lg rounded-lg">
            <div className="space-y-4">
              <div>
                <label htmlFor="shop" className="block text-sm font-medium text-gray-700 mb-2">
                  ストア名（開発用）
                </label>
                <input
                  type="text"
                  id="shop"
                  placeholder="test-store.myshopify.com"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      const shop = (e.target as HTMLInputElement).value;
                      if (shop) {
                        login(shop);
                      }
                    }
                  }}
                />
              </div>
              
              <button
                onClick={() => {
                  const shop = (document.getElementById('shop') as HTMLInputElement).value;
                  if (shop) {
                    login(shop);
                  } else {
                    alert('ストア名を入力してください');
                  }
                }}
                className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-200"
              >
                開発環境でログイン
              </button>
              
              <div className="text-center">
                <p className="text-sm text-gray-500">
                  開発環境では実際のShopify認証は行われません
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* ヘッダー */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-semibold text-gray-900">Photo Upload Form</h1>
              <span className="ml-4 px-2 py-1 text-xs bg-yellow-100 text-yellow-800 rounded">
                開発環境
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-600">
                ストア: {shop}
              </span>
              <button
                onClick={logout}
                className="text-sm text-gray-500 hover:text-gray-700 transition duration-200"
              >
                ログアウト
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
};
